import React from 'react';
import {
  Container,
  PageInput,
} from 'components/pspdf/components/pagination/style';
import { useTranslation } from 'i18n';

export interface PaginationProps {
  instance: any;
}

const defaultProps = {};

function Pagination({ instance }: PaginationProps) {
  const { t } = useTranslation();

  const [{ current, total }, setLocalPageStatus] = React.useState({
    current: instance?.viewState?.currentPageIndex + 1 ?? 1,
    total: instance?.totalPageCount ?? 1,
  });

  React.useEffect(() => {
    if (instance?.viewState?.currentPageIndex) {
      setLocalPageStatus({
        current: instance?.viewState?.currentPageIndex + 1,
        total: instance?.totalPageCount,
      });
    }
  }, [instance?.viewState?.currentPageIndex]);

  function getPageStatus() {
    if (instance) {
      return {
        current: instance.viewState.currentPageIndex + 1,
        total: instance.totalPageCount,
      };
    } else {
      return {
        current: 0,
        total: 0,
      };
    }
  }

  function setPage(page) {
    if (instance) {
      const max = instance.totalPageCount;
      const goTo = parseInt(page, 10) - 1;

      if (0 <= goTo && goTo <= max) {
        instance.setViewState((viewState) =>
          viewState.set('currentPageIndex', goTo),
        );
      }
    }
  }

  function updatePagePositionManually(event) {
    event.preventDefault();
    setPage(current);
  }

  function updatePagePositionAutomatically() {
    const { current, total } = getPageStatus();
    setLocalPageStatus({ current, total });
  }

  function updateValue(event) {
    setLocalPageStatus({ current: event.target.value, total });
  }

  React.useEffect(() => {
    if (instance) {
      instance.addEventListener(
        'viewState.change',
        updatePagePositionAutomatically,
      );

      return () =>
        instance.removeEventListener(
          'viewState.change',
          updatePagePositionAutomatically,
        );
    }
  }, [instance]);

  return (
    <Container>
      {t('Page')}
      <form onSubmit={updatePagePositionManually}>
        <PageInput
          value={current}
          max={total}
          min={1}
          onFocus={(event) => event.target.select()}
          onChange={updateValue}
        />
      </form>
      /{total}
    </Container>
  );
}

Pagination.defaultProps = defaultProps;

export default Pagination;
